import get from 'lodash/get'

export function getById(state: RootState, id: string | number) {
  return get(state, `segments.byId.${id}`)
}

export const getSegments = (state: RootState) => state.segments

export const getSegmentsById = (state: RootState) => state.segments?.byId ?? {}
